module.exports = __webpack_public_path__ + "img/Icon_18_Ihre-Flotte.f1632972.svg";